import { h } from '@stencil/core';
import { CATEGORY, tryParse } from '@pes-ui/utils';
const propsToParse = [
  { prop: '_showBreadcrumbs', target: 'showBreadcrumbs' },
  { prop: '_categoryAllData', target: 'categoryAllData' },
  { prop: '_isPBS', target: 'isPBS' },
  { prop: '_categoryId', target: 'categoryId' },
  { prop: '_countryCode', target: 'countryCode' },
  { prop: '_languageCode', target: 'languageCode' },
  { prop: '_searchParams', target: 'searchParams' },
  { prop: '_enableCommerceConnector', target: 'enableCommerceConnector' },
  { prop: '_showBuyOnline', target: 'showBuyOnline' },
  { prop: '_showCompare', target: 'showCompare' },
];
export class PesAppSprykerCategoryListing {
  constructor() {
    this._showBreadcrumbs = undefined;
    this._categoryAllData = undefined;
    this._categoryId = undefined;
    this._countryCode = undefined;
    this._languageCode = undefined;
    this._searchParams = undefined;
    this._isPBS = undefined;
    this._enableCommerceConnector = undefined;
    this._showBuyOnline = undefined;
    this._showDocuments = undefined;
    this._showCompare = undefined;
    this.host = undefined;
    this.showBreadcrumbs = undefined;
    this.categoryAllData = null;
    this.categoryId = undefined;
    this.showDocuments = true;
    this.enableCommerceConnector = true;
    this.showBuyOnline = true;
    this.productCtas = undefined;
    this.showCompare = true;
    this.isPBS = false;
    this.searchParams = {};
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.storageName = '';
    this.currentPageStorageKey = '';
  }
  componentWillLoad() {
    propsToParse.forEach(({ prop, target }) => {
      var _a;
      this[target] = ((_a = tryParse(this[prop])) !== null && _a !== void 0 ? _a : this[target]);
    });
    this.storageName = `${this.host}${this.countryCode}/${this.languageCode}/`;
    this.currentPageStorageKey = `${CATEGORY}/${this.categoryId}`;
  }
  render() {
    var _a, _b, _c;
    const { hmcBanner } = this.categoryAllData.listingInfo;
    const { analyticsPageData } = this.categoryAllData.metaTags;
    return (h("pes-app-category-subcategory-listing", { host: this.host, showBreadcrumbs: this.showBreadcrumbs, categoryOrSubcategoryId: this.categoryId, showDocuments: this.showDocuments, enableCommerceConnector: this.enableCommerceConnector, showBuyOnline: this.showBuyOnline, showCompare: this.showCompare, breadcrumbs: (_a = this.categoryAllData) === null || _a === void 0 ? void 0 : _a.breadcrumbs, descriptionInfo: (_b = this.categoryAllData) === null || _b === void 0 ? void 0 : _b.descriptionInfo, listingInfo: (_c = this.categoryAllData) === null || _c === void 0 ? void 0 : _c.listingInfo, hmcBannerInfo: hmcBanner, searchParams: this.searchParams, isSubcategoryPage: false, isPBS: this.isPBS, productCtas: this.productCtas, storageName: this.storageName, currentPageStorageKey: this.currentPageStorageKey, analyticsPageData: analyticsPageData }));
  }
  static get is() { return "pes-app-spryker-category-listing"; }
  static get encapsulation() { return "shadow"; }
  static get properties() {
    return {
      "_showBreadcrumbs": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-breadcrumbs",
        "reflect": false
      },
      "_categoryAllData": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-category-all-data",
        "reflect": false
      },
      "_categoryId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-category-id",
        "reflect": false
      },
      "_countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-country-code",
        "reflect": false
      },
      "_languageCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-language-code",
        "reflect": false
      },
      "_searchParams": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-search-params",
        "reflect": false
      },
      "_isPBS": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-is-pbs",
        "reflect": false
      },
      "_enableCommerceConnector": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-enable-commerce-connector",
        "reflect": false
      },
      "_showBuyOnline": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-buy-online",
        "reflect": false
      },
      "_showDocuments": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-documents",
        "reflect": false
      },
      "_showCompare": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-compare",
        "reflect": false
      },
      "host": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "https://www.se.com:9090"
            }],
          "text": "The host of the endpoints."
        },
        "attribute": "host",
        "reflect": false
      },
      "showBreadcrumbs": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show the breadcrumbs"
        },
        "attribute": "show-breadcrumbs",
        "reflect": false
      },
      "categoryAllData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TCategoryListingAllData",
          "resolved": "{ breadcrumbs: TBreadcrumbsData; descriptionInfo: TDescriptionInfo; listingInfo: TListingInfo; config: TConfig; recentlyViewedConfig: RecentlyViewedConfig; metaTags?: MetaTags; }",
          "references": {
            "TCategoryListingAllData": {
              "location": "import",
              "path": "../pes-app-category-listing/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Main data for category page."
        },
        "defaultValue": "null"
      },
      "categoryId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "4200"
            }],
          "text": "The ID of the category."
        },
        "attribute": "category-id",
        "reflect": false
      },
      "showDocuments": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show the documents."
        },
        "attribute": "show-documents",
        "reflect": false,
        "defaultValue": "true"
      },
      "enableCommerceConnector": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show the commerce connector."
        },
        "attribute": "enable-commerce-connector",
        "reflect": false,
        "defaultValue": "true"
      },
      "showBuyOnline": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show the buy online."
        },
        "attribute": "show-buy-online",
        "reflect": false,
        "defaultValue": "true"
      },
      "productCtas": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductCtas",
          "resolved": "{ buttons: TProductCtasButtons; productProp?: string; }",
          "references": {
            "TProductCtas": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Setup productCtas logic.\nbuttons - predefined CTA buttons.\nproductProp - predefined property of product to find in list."
        }
      },
      "showCompare": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show the compare."
        },
        "attribute": "show-compare",
        "reflect": false,
        "defaultValue": "true"
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-p-b-s",
        "reflect": false,
        "defaultValue": "false"
      },
      "searchParams": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TSearchParams",
          "resolved": "{ [x: string]: string; }",
          "references": {
            "TSearchParams": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "{}"
      },
      "countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "fr"
            }],
          "text": "The code of the country of the app."
        },
        "attribute": "country-code",
        "reflect": false
      },
      "languageCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "it"
            }],
          "text": "The code of the language of the app."
        },
        "attribute": "language-code",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "storageName": {},
      "currentPageStorageKey": {}
    };
  }
}
